import React from 'react'
import Radium from 'proofpoint-radium'

import CoreRenderFunction from '../../core/render'

const Section = ({
  children,
  id,
  style,
  content,
  className,
  updateMainContainerState,
  selectedSectionID,
  languages,
  selectedLanguageShortname
}) => {
  return (
    <div
      id={ id }
      style={{
        ...style,
        outline: selectedSectionID === id ? '2px solid #03a9f3' : 'none'
      }}
      className={ className }
      onClick={() => updateMainContainerState( 'selectedSectionID', id )}>
      {
        children && children.length > 0 ? children.map( item => {
          return (
            <CoreRenderFunction
              item={ item }
              updateMainContainerState={ updateMainContainerState }
              selectedSectionID={ selectedSectionID }
              languages={ languages }
              selectedLanguageShortname={ selectedLanguageShortname } />
          )
        }) : <div>{ content && content[ selectedLanguageShortname ] ? content[ selectedLanguageShortname ] : content[ 'en' ] }</div>
      }
    </div>
  )
}

export default Radium( Section )